import { Injectable } from "@angular/core";
import { SecretService } from "../crypto/secrets.service";
import { UserContextPermissionRoleService } from "../user/user-context-permission-role.service";
import { UserGlobalContext } from "src/app/model/user-global-context.model";
import { UserRolesAndPermissionsResponseDto } from "src/app/model/common/user-roles-permissions-response.model";
import { RolesResponseDto } from "src/app/model/common/roles-response.model";
import { BehaviorSubject, firstValueFrom } from "rxjs";
import { EXCEL_PROTECTION_PASSWORD } from "../../constants/workbook.constants";
import { GlobalStateService } from "../global-state/global-state.service";
import { Profile } from "typings";
import { MsalService } from "@azure/msal-angular";
import { ApplicationContext } from "src/app/model";
import { ExcelHelperService } from "../addin-helper-services/excel-helper.service";
import { PermissionsEnum } from "src/app/model/common/permissions.enum";

@Injectable({ providedIn: "root" })
export class UserContextInitService {
  private _userContext$ = new BehaviorSubject<UserGlobalContext | null>(null);
  private appContext: ApplicationContext;
  constructor(
    private secretService: SecretService,
    private userContextService: UserContextPermissionRoleService,
    private msalService: MsalService,
    private globalStateService: GlobalStateService,
    private excelHelper: ExcelHelperService
  ) {
    this.appContext = this.globalStateService.getWorkpaperContextData();
  }

  get userContext$() {
    return this._userContext$.asObservable();
  }

  setUserPermissionContext(context: UserGlobalContext) {
    this._userContext$.next(context);
  }

  mapToUserGlobalContext(
    dto: UserRolesAndPermissionsResponseDto
  ): UserGlobalContext {
    return {
      roles: dto.RolesList.map((r: RolesResponseDto) => r.RoleName),
      permissions: this.getPermissionsList(dto),
      isSutAdmin: dto.IsSutAdmin,
    };
  }

  getPermissionsList(dto: UserRolesAndPermissionsResponseDto) {
  
    if(dto.IsSutAdmin) {
      return Object.values(PermissionsEnum) as PermissionsEnum[];
    }
    else
    {
      return dto.PermissionsList;
    }
  }

  async setUserPermissionsContext() {
    //if (!this.appContext.currentUser || !this.appContext.userProfile) { <-- This wil prevent getting the latest permissions if the context is already set
      const account: Profile | undefined =
        await this.msalService.instance.getAllAccounts()[0];
      if (account) {
        const employeeId = account?.idTokenClaims?.employeeID ?? "unknown";
        this.appContext.currentUser = employeeId;
        this.appContext.userProfile = {
          name: account?.idTokenClaims?.name?.trim() ?? "firstname.lastname",
          employeeID: employeeId.toString(),
        };
        return new Promise<void>((resolve) => {
          this.userContextService
            .getUserContextWithPermissionsAndRoles(employeeId.toString())
            .subscribe((rolesAndPermissions) => {
              if (rolesAndPermissions) {
                const mapped = this.mapToUserGlobalContext(rolesAndPermissions);
                this.setUserPermissionContext(mapped);
              }
              resolve();
            });
        });
      //}
    }
  }

  async setPassword() {
    if (!this.appContext.workpaperPassword || this.appContext.workpaperPassword.length === 0) {
      const response = this.secretService.hasSecret(EXCEL_PROTECTION_PASSWORD);
      if (!response) {
        await firstValueFrom(
          this.secretService.loadSecrets([EXCEL_PROTECTION_PASSWORD])
        );
      }
      this.appContext.workpaperPassword = this.secretService.getSecret(
        EXCEL_PROTECTION_PASSWORD
      ) as string;
    }
  }

  async protectWorkbook() {
    const password = this.appContext.workpaperPassword;
    if (
      this.appContext.workpaperPassword &&
      typeof password === "string" &&
      password.length > 0
    ) {
      await this.excelHelper.protectWorkbook(password);
    } else {
      console.error("workpaperPassword is missing or invalid");
    }
  }
}
